

export default class Validator {



    static CalculateValidCheckDigit(e: any) {
        for (var r, a = 0, s = !0; e > 0;){
            r = e % 10;
            a += (s ? (Math.floor(2 * r / 10) + 2 * r % 10) : r);
            s = !s;
            e = Math.floor(e / 10);
        }
         
        return a %= 10, 0 === a ? a : 10 - a
    }

    static IdIsValide(id: any) {    
        return /\d{9}/.test(id) && Array.from(id, Number).reduce((counter, digit, i) => {
            const step = digit * ((i % 2) + 1);
            return counter + (step > 9 ? step - 9 : step);
        }) % 10 === 0;    
    }

    static IsValidEmail(email: string){
        //const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/igm;
        const regex = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        return regex.test(email);
    }

    static IsValidPhone(phone: string){
        const regex = /^\+[0-9]+$/;
        return regex.test(phone);
    }

    
    static IsValidPassword(password: string){
        
        return password.length > 0;
    }
}